import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { createMuiTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/styles'
import grey from '@material-ui/core/colors/grey'

import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

const theme = createMuiTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 400,
			md: 750,
			lg: 1280,
			xl: 1920,
		},
	},
	palette: {
		primary: {
			main: '#8759f1',
			contrastText: '#fff',
		},
		secondary: {
			main: '#3db8f1',
			contrastText: '#fff',
		},
		background: {
			default: grey[100],
		},
	},
	typography: {
		fontFamily: "'Noto Sans KR', sans-serif",
	},
})

ReactDOM.render(
	<MuiPickersUtilsProvider utils={DateFnsUtils}>
		<ThemeProvider theme={theme}>
			<App />
			<CssBaseline />
		</ThemeProvider>
	</MuiPickersUtilsProvider>,
	document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
